import { Link } from 'react-router-dom';
import { useState } from 'react';

const NEWSLETTER_FORM_URL = 'http://chinahangnuo.com/';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '热门漫画', path: '/#popular' },
    { name: '最新更新', path: '/#latest' },
    { name: '关于我们', path: '/about' },
    { name: '联系合作', path: '/about#contact' },
  ],
  categories: [
    { name: '热血漫画', path: '/category/action' },
    { name: '恋爱漫画', path: '/category/romance' },
    { name: '奇幻漫画', path: '/category/fantasy' },
    { name: '悬疑漫画', path: '/category/mystery' },
  ],
  support: [
    { name: '常见问题', path: '/about#faq' },
    { name: '版权声明', path: '/about' },
    { name: '服务条款', path: '/about' },
    { name: '隐私政策', path: '/about' },
    { name: '联系我们', path: '/about#contact' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setErrorMsg('');

    const form = e.currentTarget as HTMLFormElement;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setSubmitted(true);
      setEmail('');
      setLoading(false);
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const res = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || '提交失败，请稍后再试';
        setErrorMsg(msg);
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-bold font-heading text-background-50">韩漫画网</span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed mb-6 max-w-sm">
                韩漫画网提供最全面的免费韩国漫画在线阅读服务。涵盖热血、恋爱、奇幻、悬疑等多种类型，每天更新，画质清晰，是您漫画爱好者的最佳选择。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" aria-label="QQ" rel="nofollow">
                  <i className="ri-qq-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" aria-label="B站" rel="nofollow">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {footerLinks.categories.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">帮助支持</h4>
              <ul className="space-y-2.5">
                {footerLinks.support.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700/50 pt-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-2">订阅更新</h4>
              <p className="text-xs text-foreground-400 mb-3">获取最新漫画更新通知和推荐</p>
              <form className="flex flex-col sm:flex-row gap-2" onSubmit={handleNewsletter}>
                <input
                  type="text"
                  name="website_alt"
                  className="honeypot-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入您的邮箱"
                  className="bg-background-800 border border-background-700 rounded-full px-4 py-2 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-accent-500 transition-colors duration-200 w-full sm:w-56"
                  required
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-accent-500 text-background-50 px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors duration-200 cursor-pointer disabled:opacity-60"
                >
                  {loading ? '提交中...' : submitted ? '已订阅 ✓' : '订阅'}
                </button>
              </form>
              {submitted && !loading && (
                <p className="text-xs text-accent-400 mt-2">订阅成功！感谢您的关注。</p>
              )}
              {errorMsg && (
                <p className="text-xs text-red-400 mt-2">{errorMsg}</p>
              )}
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 韩漫画网 HanManHua.com 版权所有
            </p>
            <p className="text-xs text-foreground-500">
              本站内容仅供学习交流，版权归原作者所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}